const languages = () => ({
  en: { name: 'English' },
  fr: { name: 'Français' },
  // jhipster-needle-i18n-language-key-pipe - JHipster will add/remove languages in this object
});

export default languages;
